import { useMutation } from '@tanstack/react-query';

import { usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface UseSaveInstanceMutationProps {
  savedInstances: { instanceId: string }[];
}

export const useSaveInstance = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/saved-instances`;

  return useMutation(({ savedInstances }: UseSaveInstanceMutationProps) =>
    makeRequest({
      url,
      method: 'POST',
      data: savedInstances,
    })
  );
};

export const useUnSaveInstance = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/saved-instances`;

  return useMutation(({ savedInstances }: { savedInstances: string[] }) =>
    makeRequest({
      url,
      method: 'DELETE',
      data: {
        params: {
          savedInstanceIds: savedInstances.join(','),
        },
      },
    })
  );
};
